// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@nrwl/web/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".avatar_avatar__1IJ_J {\n  border-radius: 50%;\n  overflow: hidden;\n  border: 1px solid #ffffff;\n}\n.avatar_avatar__1IJ_J img {\n  width: 100%;\n  height: 100%;\n  background-position: center;\n  background-repeat: no-repeat;\n}", ""]);
// Exports
exports.locals = {
	"avatar": "avatar_avatar__1IJ_J"
};
module.exports = exports;
